<template>
  <div>
    <div class="p-relative header-image pb-5"></div>

    <b-container class="custom-container mt-5">
      <b-row>
        <b-col cols="12" class="px-3">
          <b-container fluid>
            <b-row>
              <b-col cols="12" sm="6">
                <h4 class="font-weight-bold pt-4 mb-4 align-middle">Trades</h4>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-card
                  border-variant="light"
                  bg-variant="light"
                  body-class="px-0 py-0"
                >
                  <trade-list />
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
// import ProjectsList from '@/components/lists/ProjectList'
import TradeList from '@/components/lists/TradeList'

export default {
  components: {
    TradeList,
  },
}
</script>
